import React, {Component} from 'react'
import PrintPreview from '../PrintPreview'
import PdfStore from '../../../stores/PdfStore'
import './Print.css'
import Moment from 'moment';

var NotificationSystem = require('react-notification-system');
const DEFAUT_ROW = 20
class PrintDearPartDisposebyReturn extends Component {

  constructor(...args){
    super(...args)
    
    this.state = {
      loading:false,
      show_receiving_detail:true,
      data:{partlist:this.newEmptyRow(DEFAUT_ROW)},
      report_title:'กำลังดึงข้อมูล..'
    }

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('portrait');
  }

  componentDidMount(){
    this.loadData()
  }

  getTextMonth(month) {
    return month=='01'||month=='1' ? 'มกราคม' : month=='02'||month=='2' ? 'กุมภาพันธ์' : month=='03'||month=='3' ? 'มีนาคม' : month=='04'||month=='4' ? 'เมษายน' : month=='05'||month=='5' ? 'พฤษภาคม' : month=='06'||month=='6' ? 'มิถุนายน' : month=='07'||month=='7' ? 'กรกฎาคม' : month=='08'||month=='8' ? 'สิงหาคม' : month=='09'||month=='9' ? 'กันยายน' : month=='10' ? 'ตุลาคม' : month=='11' ? 'พฤศจิกายน' : month=='12' ? 'ธันวาคม' : ''
  }

  newEmptyRow(number){
  	return new Array(number).fill(null).map((item,index)=>{
      return {detail:''}
    })
  }

  loadData() {
  	let {data} = this.state
  	this.setState({loading:true})
    PdfStore.loadPartdisposeByReturnDoc(this.props.workNo,(result)=>{
      data = result.data
      if (data.partlist!==undefined&&data.partlist.length>0) {
        if (data.partlist.length<DEFAUT_ROW)
          data.partlist = data.partlist.concat(this.newEmptyRow(DEFAUT_ROW-data.partlist.length))
      }else{
        data.partlist = this.newEmptyRow(DEFAUT_ROW);
      }
      this.setState({data:data})
    })
  }

  renderComponentPage() {
    let {data} = this.state
    return(
      <div className='font-print print-dear-part'>
        <table className='table table-no-bd'>
          <tbody>
            <tr>
              <td  className='text-right'></td>
              <td style={{width:'350px'}} className='text-center bd-b-d'>{data.insurer?data.insurer.insurer_name:''}</td>
              <td className='text-left'></td>
            </tr>
            <tr>
              <td colSpan={3} className='text-center'><br /></td>
            </tr>
            <tr>
              <td colSpan={3} className='text-center'>{this.props.title}</td>
            </tr>
          </tbody>  
        </table>
        <table className='table table-no-bd' style={{marginTop:'20px'}}>
          <tbody> 
            <tr>
              <td style={{width:'600px'}} className='text-right'></td>
              <td style={{width:'50px'}} className='text-right'>วันที่</td>
              <td style={{width:'100px'}} className='text-center bd-b-d'>{Moment().format('DD')*1}</td>
              <td style={{width:'50px'}} className='text-center'>เดือน</td>
              <td style={{width:'150px'}} className='text-center bd-b-d'>{this.getTextMonth(Moment().format('MM'))}</td>
              <td style={{width:'50px'}} className='text-left'>พ.ศ.</td>
              <td style={{width:'150px'}} className='text-center bd-b-d'>{Moment().format('YYYY')}</td>
            </tr>
          </tbody>  
        </table>
        <table className='table table-no-bd' style={{marginTop:'20px'}}>
          <tbody> 
            <tr>
              <td style={{width:'100px'}} className='text-right'></td>
              <td className='text-left'>เรียนผู้จัดการฝ่ายสินไหมทดแทน</td>
            </tr>
          </tbody>  
        </table>
        <table className='table table-no-bd'>
          <tbody> 
            <tr>
              <td style={{width:'300px'}} className='text-right'></td>
              <td style={{width:'150px'}} className='text-right'>ด้วยข้าพเจ้า</td>
              <td style={{width:'500px'}} className='text-center bd-b-d'></td>
              <td style={{width:'800px'}} className='text-left'>ได้รับอะไหล่เก่าของรถยนต์ ประกันภัย / คู่กรณี</td>
            </tr>
          </tbody>  
        </table>    
        <table className='table table-no-bd'>
          <tbody>    
            <tr>
              <td style={{width:'100px'}} className='text-right'>ยี่ห้อ/รุ่น</td>
              <td style={{width:'250px'}} className='text-center bd-b-d'>{data.car?data.car.brand+'/':''}{data.car?data.car.model:''}</td>
              <td style={{width:'50px'}} className='text-center'></td>
              <td style={{width:'100px'}}>ทะเบียน</td>
              <td style={{width:'250px'}} className='text-center bd-b-d'>{data.car?data.car.car_registration_no:''}</td>
              <td style={{width:'50px'}} className='text-center'></td>
              <td style={{width:'100px'}}>เลขเคลม</td>
              <td style={{width:'250px'}} className='text-center bd-b-d'>{data.insurer?data.insurer.claim_no:''}</td>
            </tr>
          </tbody>  
        </table>
        <table className='table table-no-bd' style={{marginTop:'20px'}}>
          <tbody> 
            <tr>
              <td style={{width:'100px'}} className='text-right'></td>
              <td className='text-left'>จาก {data.company_name?data.company_name:""}</td>
            </tr>
          </tbody>  
        </table>
        <br />
        <div style={{display:'flex'}}>
          <div style={{width:'49%'}}>
            <table className='table table-no-bd'>
              <tbody> 
                {data.partlist.map((item,index)=>{
                  if (index<10) {
                    return(
                      <tr key={index}>
                        <td style={{width:'50px'}} className='text-right'>{index+1}</td>
                        <td style={{width:'200px'}} className='bd-b-d2 text-left'>{item.detail}</td>
                      </tr>
                    )  
                  }
                })}
              </tbody>  
            </table>
          </div>
          <div style={{width:'49%'}}>
            <table className='table table-no-bd'>
              <tbody> 
                {data.partlist.map((item,index)=>{
                  if (index>=10) {
                    return(
                      <tr key={index}>
                        <td style={{width:'50px'}} className='text-right'>{index+1}</td>
                        <td style={{width:'200px'}} className='bd-b-d2 text-left'>{item.detail}</td>
                      </tr>
                    )  
                  }  
                })}
              </tbody>  
            </table>
          </div>  
        </div> 
        <table className='table table-no-bd' style={{marginTop:'100px'}}>
          <tbody> 
            <tr>
              <td style={{width:'600px'}} className='text-right'></td>
              <td style={{width:'50px'}} className='text-right'>ลงชื่อ</td>
              <td style={{width:'150px'}} className='text-center bd-b-d'></td>
              <td style={{width:'100px'}} className='text-left'>ผู้ส่งอะไหล่</td>
            </tr>
            <tr>
              <td className='text-right'></td>
              <td className='text-right'>วันที่</td>
              <td style={{width:'150px'}} className='text-center bd-b-d'></td>
              <td className='text-left'></td>
            </tr>
          </tbody>  
        </table>
        <table className='table table-no-bd' style={{marginTop:'50px'}}>
          <tbody> 
            <tr>
              <td style={{width:'600px'}} className='text-right'></td>
              <td style={{width:'50px'}} className='text-right'>ลงชื่อ</td>
              <td style={{width:'150px'}} className='text-center bd-b-d'></td>
              <td style={{width:'100px'}} className='text-left'>ผู้รับอะไหล่</td>
            </tr>            
            <tr>
              <td className='text-right'></td>
              <td className='text-right'>วันที่</td>
              <td style={{width:'150px'}} className='text-center bd-b-d'></td>
              <td className='text-left'></td>
            </tr>
          </tbody>  
        </table>
      </div>
    )
  }

  render() {
    let {loading} = this.state
    return(
      <div>
          <PrintPreview
              loading={loading}
              leftBarTitle={this.props.title}
              showPageNumber={false}
          >
              {this.renderComponentPage()}
          </PrintPreview>
          <NotificationSystem ref="notificationSystem" />
      </div>
    ) 
  }   
}  

PrintDearPartDisposebyReturn.defaultProps = {
  title:'ใบคืนซาก'
}
export default PrintDearPartDisposebyReturn;


// WEBPACK FOOTER //
// ./src/view/print/dear/PrintDearPartDisposebyReturn.js